// Static site config for the public app. No auth, no per-role branching —
// this app is the same for every visitor, so it stays plain data (unlike
// src/config/rbacConfig.js, which exists because the main NLIMS app IS
// role-gated).
export const SITE_NAME = 'National Livestock Information Management System';
export const SITE_SHORT_NAME = 'NLIMS';

// Each tab is its own page/component (see src/Pages/public/pages).
export const NAV_LINKS = [
  { to: '', label: 'Overview' },
  { to: 'markets-prices', label: 'Markets Prices' },
  { to: 'facilities-services', label: 'Facilities & Services' },
  { to: 'livestock-production', label: 'Livestock Production' },
  { to: 'service-professionals', label: 'Service Professionals' },
  { to: 'contact-us', label: 'Contact Us' },
];
